"use client"

import type React from "react"
import { useState } from "react"

interface DropdownItem {
  label: string
  icon?: React.ReactNode
  onClick: () => void
  danger?: boolean
}

interface DropdownProps {
  items: DropdownItem[]
  children: React.ReactNode
  onOpen?: () => void
}

const Dropdown: React.FC<DropdownProps> = ({
  items,
  children,
  onOpen,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="relative">
      {/* Trigger */}
      <div
      onClick={(e) => {
        e.stopPropagation()

        setIsOpen((prev) => {
          const nextState = !prev

          if (nextState) {
            onOpen?.()
          }

          return nextState
        })
      }}
      className="cursor-pointer"
    >
      {children}
    </div>

      {/* Dropdown menu */}
      {isOpen && (
        <>
          {/* Outside click overlay */}
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          <div className="absolute right-0 top-full z-50 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="py-1">
              {items.map((item, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation()
                    item.onClick()
                    setIsOpen(false)
                  }}
                  className={`${
                    item.danger
                      ? "text-red-600 hover:bg-red-50"
                      : "text-gray-700 hover:bg-gray-100"
                  } flex w-full items-center px-4 py-2 text-sm text-left`}
                >
                  {item.icon && (
                    <span className="mr-2">
                      {item.icon}
                    </span>
                  )}

                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Dropdown